import NewsComp from "../../components/news/NewsComp"
import { useTranslation } from "react-i18next"

export default function News008() {

    const { t } = useTranslation()

    const newsText = [
        t('news:news.8.p1'),
        t('news:news.8.p2'),
        t('news:news.8.p3'),
        t('news:news.8.p4'),
        t('news:news.8.p5'),
        t('news:news.8.p6'),
        t('news:news.8.p7'),
		t('news:news.8.p8')
    ]

    const newsImage = [
        "news008-img1.jpg",
        "news008-img2.jpg",
        "news008-img3.jpg",
        "news008-img4.jpg"
    ]
    return (
        <div>
            <NewsComp
                newsImage={newsImage}
                newsText={newsText}
                date="2026-05-30"
                headline={t('news:headline.8')}
            />
        </div>
    )
}